var _defs, _g, _rect, _rect2, _rect3, _g2, _rect4, _rect5, _rect6, _g3, _rect7, _rect8, _rect9, _path, _line, _path2, _line2, _path3, _line3, _path4, _line4, _rect10, _rect11, _rect12, _rect13, _path5, _rect14, _g4, _path6, _line5, _path7, _line6, _path8, _line7, _path9, _line8, _rect15, _g5, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _g6, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _path10, _path11, _rect48, _rect49, _rect50, _g7, _rect51, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHosting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_874",
    "data-name": "Group 874",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111.631,
    height: 85.524,
    viewBox: "0 0 111.631 85.524",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_519",
    "data-name": "Rectangle 519",
    width: 111.631,
    height: 85.524
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M40.22,49.378H5.941a.691.691,0,0,1-.691-.691V27.471a.691.691,0,0,1,.691-.691H40.22a.691.691,0,0,1,.691.691V48.686a.685.685,0,0,1-.691.691",
    transform: "translate(-2.521 -12.859)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M6.2,49.955v-19.1a.546.546,0,0,1,.546-.546H40.333a.546.546,0,0,1,.546.546v19.1a.546.546,0,0,1-.546.546H6.746a.546.546,0,0,1-.546-.546",
    transform: "translate(-2.977 -14.554)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M71.634,28.122a.452.452,0,1,1-.452-.452.453.453,0,0,1,.452.452",
    transform: "translate(-33.961 -13.286)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M68.765,28.122a.452.452,0,1,1-.452-.452.453.453,0,0,1,.452.452",
    transform: "translate(-32.583 -13.286)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M65.895,28.122a.452.452,0,1,1-.452-.452.453.453,0,0,1,.452.452",
    transform: "translate(-31.205 -13.286)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M12.239,35.575a1.825,1.825,0,1,1-1.825-1.825,1.824,1.824,0,0,1,1.825,1.825",
    transform: "translate(-4.125 -16.205)",
    fill: "#ffcc6e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_525",
    "data-name": "Rectangle 525",
    width: 27.224,
    height: 0.863,
    transform: "translate(8.952 17.555)",
    fill: "#d6d4eb"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_526",
    "data-name": "Rectangle 526",
    width: 18.532,
    height: 0.863,
    transform: "translate(8.952 18.938)",
    fill: "#d6d4eb"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_527",
    "data-name": "Rectangle 527",
    width: 9.638,
    height: 0.863,
    transform: "translate(8.952 20.404)",
    fill: "#d6d4eb"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M12.239,46.765a1.825,1.825,0,1,1-1.825-1.825,1.824,1.824,0,0,1,1.825,1.825",
    transform: "translate(-4.125 -21.578)",
    fill: "#3da1b8"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_529",
    "data-name": "Rectangle 529",
    width: 27.224,
    height: 0.863,
    transform: "translate(8.952 23.372)",
    fill: "#d6d4eb"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_530",
    "data-name": "Rectangle 530",
    width: 18.532,
    height: 0.863,
    transform: "translate(8.952 24.755)",
    fill: "#d6d4eb"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_531",
    "data-name": "Rectangle 531",
    width: 9.638,
    height: 0.863,
    transform: "translate(8.952 26.216)",
    fill: "#d6d4eb"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M12.239,57.945a1.825,1.825,0,1,1-1.825-1.825,1.824,1.824,0,0,1,1.825,1.825",
    transform: "translate(-4.125 -26.946)",
    fill: "#ff5e63"
  })))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_533",
    "data-name": "Rectangle 533",
    width: 27.224,
    height: 0.863,
    transform: "translate(8.952 29.189)",
    fill: "#d6d4eb"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_534",
    "data-name": "Rectangle 534",
    width: 18.532,
    height: 0.863,
    transform: "translate(8.952 30.567)",
    fill: "#d6d4eb"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_535",
    "data-name": "Rectangle 535",
    width: 9.638,
    height: 0.863,
    transform: "translate(8.952 32.033)",
    fill: "#d6d4eb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M76.673,73.5v.468H76.2",
    transform: "translate(-36.588 -35.292)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x1: 36.966,
    transform: "translate(1.71 38.676)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.967 2.967"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M1.953,73.968H1.48V73.5",
    transform: "translate(-0.711 -35.292)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    y1: 24.323,
    transform: "translate(0.769 12.928)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.058 3.058"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M1.48,23.513V23.04h.473",
    transform: "translate(-0.711 -11.063)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    x2: 36.966,
    transform: "translate(2.178 11.977)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "2.967 2.967"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M76.2,23.04h.473v.473",
    transform: "translate(-36.588 -11.063)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    y2: 24.329,
    transform: "translate(40.085 13.402)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.058 3.058"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_536",
    "data-name": "Rectangle 536",
    width: 1.539,
    height: 1.539,
    transform: "translate(0 11.208)",
    fill: "#140578"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_537",
    "data-name": "Rectangle 537",
    width: 1.539,
    height: 1.539,
    transform: "translate(0 37.907)",
    fill: "#140578"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_538",
    "data-name": "Rectangle 538",
    width: 1.539,
    height: 1.539,
    transform: "translate(39.316 11.208)",
    fill: "#140578"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_539",
    "data-name": "Rectangle 539",
    width: 1.539,
    height: 1.539,
    transform: "translate(39.316 37.907)",
    fill: "#38366e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M155.02,110.283v-.473h.473",
    transform: "translate(-74.434 -52.726)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_540",
    "data-name": "Rectangle 540",
    width: 1.19,
    height: 1.19,
    transform: "translate(79.994 56.486)",
    fill: "#38366e"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(23.897 26.626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M111.86,90.541H47.41a1.44,1.44,0,0,1-1.44-1.44V52.66a1.44,1.44,0,0,1,1.44-1.44h64.45a1.44,1.44,0,0,1,1.44,1.44V89.1a1.44,1.44,0,0,1-1.44,1.44",
    transform: "translate(-45.97 -51.22)",
    fill: "#140578"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M47.76,91.794V58.758a.87.87,0,0,1,.868-.868h63.738a.87.87,0,0,1,.868.868V91.794a.87.87,0,0,1-.868.868H48.628a.866.866,0,0,1-.868-.868",
    transform: "translate(-46.829 -54.423)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M171.3,53.773a.853.853,0,1,1-.853-.853.85.85,0,0,1,.853.853",
    transform: "translate(-105.327 -52.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M165.875,53.773a.853.853,0,1,1-.853-.853.85.85,0,0,1,.853.853",
    transform: "translate(-102.724 -52.036)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M160.455,53.773a.853.853,0,1,1-.853-.853.85.85,0,0,1,.853.853",
    transform: "translate(-100.122 -52.036)",
    fill: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M98.433,95.08v.473H97.96",
    transform: "translate(-47.036 -45.653)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x1: 22.499,
    transform: "translate(27.469 49.9)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.059 3.059"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M51.483,95.553H51.01V95.08",
    transform: "translate(-24.493 -45.653)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    y1: 15.424,
    transform: "translate(26.517 33.005)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.114 3.114"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M51.01,62.1V61.63h.473",
    transform: "translate(-24.493 -29.592)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x2: 22.499,
    transform: "translate(27.947 32.038)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.059 3.059"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M97.96,61.63h.473V62.1",
    transform: "translate(-47.036 -29.592)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    y2: 15.424,
    transform: "translate(51.397 33.504)",
    fill: "none",
    stroke: "#38366e",
    strokeLinejoin: "round",
    strokeWidth: 1.049,
    strokeDasharray: "3.114 3.114"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_541",
    "data-name": "Rectangle 541",
    width: 24.88,
    height: 17.862,
    transform: "translate(29.423 34.913)",
    fill: "#140578"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M74.733,73.346a2.126,2.126,0,1,1-2.126-2.126A2.125,2.125,0,0,1,74.733,73.346Zm6.581,12.2H59.6l6.841-12.9L71.582,81.5l3.488-3.68Z",
    transform: "translate(-28.617 -34.197)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_543",
    "data-name": "Rectangle 543",
    width: 30.993,
    height: 1.908,
    transform: "translate(57.167 32.313)",
    fill: "#d6d4eb"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_544",
    "data-name": "Rectangle 544",
    width: 8.905,
    height: 0.951,
    transform: "translate(57.167 35.822)",
    fill: "#d6d4eb"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_545",
    "data-name": "Rectangle 545",
    width: 3.613,
    height: 0.951,
    transform: "translate(67.289 35.822)",
    fill: "#d6d4eb"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_546",
    "data-name": "Rectangle 546",
    width: 9.487,
    height: 0.951,
    transform: "translate(72.289 35.822)",
    fill: "#d6d4eb"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_547",
    "data-name": "Rectangle 547",
    width: 5.635,
    height: 0.951,
    transform: "translate(82.525 35.822)",
    fill: "#d6d4eb"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_548",
    "data-name": "Rectangle 548",
    width: 11.743,
    height: 0.951,
    transform: "translate(57.167 38.198)",
    fill: "#d6d4eb"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_549",
    "data-name": "Rectangle 549",
    width: 4.569,
    height: 0.951,
    transform: "translate(70.21 38.198)",
    fill: "#d6d4eb"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_550",
    "data-name": "Rectangle 550",
    width: 4.569,
    height: 0.951,
    transform: "translate(75.819 38.198)",
    fill: "#d6d4eb"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_551",
    "data-name": "Rectangle 551",
    width: 5.801,
    height: 0.951,
    transform: "translate(81.096 38.198)",
    fill: "#d6d4eb"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_552",
    "data-name": "Rectangle 552",
    width: 3.27,
    height: 0.951,
    transform: "translate(57.167 40.574)",
    fill: "#d6d4eb"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 5.869,
    height: 0.951,
    transform: "translate(72.492 40.574)",
    fill: "#d6d4eb"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_554",
    "data-name": "Rectangle 554",
    width: 10.324,
    height: 0.951,
    transform: "translate(61.186 40.574)",
    fill: "#d6d4eb"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 7.403,
    height: 0.951,
    transform: "translate(57.167 42.949)",
    fill: "#d6d4eb"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_556",
    "data-name": "Rectangle 556",
    width: 2.485,
    height: 0.951,
    transform: "translate(65.843 42.949)",
    fill: "#d6d4eb"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 4.887,
    height: 0.951,
    transform: "translate(69.487 42.949)",
    fill: "#d6d4eb"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_558",
    "data-name": "Rectangle 558",
    width: 2.833,
    height: 0.951,
    transform: "translate(57.167 45.32)",
    fill: "#d6d4eb"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_559",
    "data-name": "Rectangle 559",
    width: 6.217,
    height: 0.951,
    transform: "translate(61.071 45.32)",
    fill: "#d6d4eb"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_560",
    "data-name": "Rectangle 560",
    width: 27.791,
    height: 8.265,
    transform: "translate(26.517 54.672)",
    fill: "#d6d4eb"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_561",
    "data-name": "Rectangle 561",
    width: 5.276,
    height: 4.907,
    transform: "translate(27.255 55.233)",
    fill: "#fff"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_562",
    "data-name": "Rectangle 562",
    width: 5.276,
    height: 1.456,
    transform: "translate(27.255 60.868)",
    fill: "#fff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 5.276,
    height: 4.907,
    transform: "translate(33.977 57.422)",
    fill: "#fff"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 5.276,
    height: 1.456,
    transform: "translate(33.977 55.233)",
    fill: "#fff"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_565",
    "data-name": "Rectangle 565",
    width: 5.276,
    height: 4.907,
    transform: "translate(41.218 55.233)",
    fill: "#fff"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_566",
    "data-name": "Rectangle 566",
    width: 5.276,
    height: 1.456,
    transform: "translate(41.218 60.868)",
    fill: "#fff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_567",
    "data-name": "Rectangle 567",
    width: 5.276,
    height: 4.907,
    transform: "translate(47.935 57.422)",
    fill: "#fff"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_568",
    "data-name": "Rectangle 568",
    width: 5.276,
    height: 1.456,
    transform: "translate(47.935 55.233)",
    fill: "#fff"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M142.494,94H111.21V92.94a.65.65,0,0,1,.65-.65h29.985a.65.65,0,0,1,.65.65Z",
    transform: "translate(-53.398 -44.314)",
    fill: "#140578"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M142.494,94.34H111.21v13.272a.853.853,0,0,0,.853.853h29.574a.853.853,0,0,0,.853-.853V94.34Zm-.317.317v12.954a.544.544,0,0,1-.541.541H112.063a.544.544,0,0,1-.541-.541V94.657Z",
    transform: "translate(-53.398 -45.298)",
    fill: "#140578"
  })))), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 19.016,
    height: 11.353,
    transform: "translate(68.708 50.742)",
    fill: "#d6d4eb"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_572",
    "data-name": "Rectangle 572",
    width: 17.072,
    height: 1.159,
    transform: "translate(69.721 51.345)",
    fill: "#fff"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_573",
    "data-name": "Rectangle 573",
    width: 17.072,
    height: 0.577,
    transform: "translate(69.721 53.201)",
    fill: "#fff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_574",
    "data-name": "Rectangle 574",
    width: 3.935,
    height: 1.357,
    transform: "translate(63.665 53.201)",
    fill: "#d6d4eb"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_575",
    "data-name": "Rectangle 575",
    width: 3.67,
    height: 6.945,
    transform: "translate(69.721 54.303)",
    fill: "#fff"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 3.67,
    height: 6.945,
    transform: "translate(78.741 54.303)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M143.047,111.1h3.358v-6.628h-3.358Zm3.67.317H142.73V104.15h3.987Z",
    transform: "translate(-68.533 -50.008)",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M159.912,111.1h3.358v-6.628h-3.358Zm3.675.317H159.6V104.15h3.987Z",
    transform: "translate(-76.633 -50.008)",
    fill: "#fff"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_577",
    "data-name": "Rectangle 577",
    width: 3.935,
    height: 1.357,
    transform: "translate(63.665 55.654)",
    fill: "#d6d4eb"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_578",
    "data-name": "Rectangle 578",
    width: 3.935,
    height: 1.357,
    transform: "translate(63.665 58.113)",
    fill: "#d6d4eb"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_579",
    "data-name": "Rectangle 579",
    width: 3.935,
    height: 1.357,
    transform: "translate(63.665 60.567)",
    fill: "#d6d4eb"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M99.352,24.21H87.988a2.73,2.73,0,0,0-2.417,4l-.889,1.617a.485.485,0,0,0,.613.681l2.121-.9a2.558,2.558,0,0,0,.567.062H99.347a2.729,2.729,0,0,0,.005-5.458",
    transform: "translate(-40.631 -11.625)",
    fill: "#f3a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M92.144,28.607a.967.967,0,1,1-.967-.967.965.965,0,0,1,.967.967",
    transform: "translate(-43.315 -13.272)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M98.924,28.607a.967.967,0,1,1-.967-.967.965.965,0,0,1,.967.967",
    transform: "translate(-46.57 -13.272)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M105.7,28.607a.967.967,0,1,1-.967-.967.965.965,0,0,1,.967.967",
    transform: "translate(-49.826 -13.272)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M112.484,28.607a.967.967,0,1,1-.967-.967.965.965,0,0,1,.967.967",
    transform: "translate(-53.081 -13.272)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M180.542,77.44H169.178a2.729,2.729,0,0,0-2.729,2.729h0a2.741,2.741,0,0,0,.312,1.268l-.889,1.617a.485.485,0,0,0,.613.681l2.121-.9a2.559,2.559,0,0,0,.567.062h11.364a2.729,2.729,0,0,0,2.729-2.729h0a2.721,2.721,0,0,0-2.724-2.729",
    transform: "translate(-79.615 -37.183)",
    fill: "#f3a51c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M173.334,81.827a.967.967,0,1,1-.967-.967.965.965,0,0,1,.967.967",
    transform: "translate(-82.299 -38.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M180.114,81.827a.967.967,0,1,1-.967-.967.965.965,0,0,1,.967.967",
    transform: "translate(-85.554 -38.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M186.894,81.827a.967.967,0,1,1-.967-.967.965.965,0,0,1,.967.967",
    transform: "translate(-88.81 -38.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M193.674,81.827a.967.967,0,1,1-.967-.967.965.965,0,0,1,.967.967",
    transform: "translate(-92.065 -38.826)",
    fill: "#fff"
  })))), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_590",
    "data-name": "Rectangle 590",
    width: 18.288,
    height: 4.72,
    transform: "translate(4.19 43.911)",
    fill: "#9c2eff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M15.394,85.93l-1.138,3.14h-.879L12.67,87.12l-.728,1.949h-.879L9.93,85.93h.858l.743,2.126L12.3,85.93h.775l.749,2.126.764-2.126Z",
    transform: "translate(-4.768 -41.26)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M25.774,85.93l-1.138,3.14h-.879L23.05,87.12l-.728,1.949h-.879L20.31,85.93h.863l.738,2.126.775-2.126h.769l.749,2.126.764-2.126Z",
    transform: "translate(-9.752 -41.26)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M36.158,85.93,35.02,89.07h-.879l-.707-1.949-.728,1.949h-.873L30.7,85.93h.858l.738,2.126.775-2.126h.769l.749,2.126.764-2.126Z",
    transform: "translate(-14.741 -41.26)",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M7.167,84.47v4.72M6.2,89.2H8.139M6.2,84.47H8.139",
    transform: "translate(-2.977 -40.559)",
    fill: "none",
    stroke: "#38366e",
    strokeMiterlimit: 10,
    strokeWidth: 2.098
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M102.982,84.048l-1.6-.431-1.6-.426.426,1.6.431,1.6.879-.879,1.83,1.83.587-.587-1.83-1.83Z",
    transform: "translate(-47.91 -39.944)",
    fill: "#f2a61c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHosting);
export default __webpack_public_path__ + "static/media/hosting.c8db5f4accc71468f87e57c4e43ff966.svg";
export { ForwardRef as ReactComponent };